import { createReducer } from '../../common/reduxHelpers';
import * as types from './actionTypes';

export const initialState = {};

const reducer = createReducer(initialState, {
   [types.FETCH_SUCCESS](state, action){
       return action.response;
   } 
});

export default reducer;